import { fetchSymbol } from "../fetch/fetch-helper";
import { z } from 'zod';

const sectionsResponseSchema = z.record(z.string());

type SectionsResponse = z.infer<typeof sectionsResponseSchema>;

const parseSectionHTML = (html: string) => (new DOMParser()).parseFromString(html, 'text/html').querySelector(`.shopify-section`)

export async function getAll(sections: string | string[], url: string = '/', noIntercept?: boolean): Promise<{ [k: string]: HTMLElement }> {
  const parsed = Array.isArray(sections) ? sections : [sections];
  const response = await window[fetchSymbol].getJSON<SectionsResponse>(url, { sections: parsed.join(',') }, noIntercept);
  const parsedResponse = sectionsResponseSchema.safeParse(response);
  if (!parsedResponse.success) throw new TypeError(`Invalid sections response`);
  const sectionsObject: Record<string, HTMLElement> = {};
  for (const [key, value] of Object.entries(response)) {
    const section = parseSectionHTML(value);
    if (!section) {
      console.error(`Couldn't find section with id ${key}`);
      continue;
    }
    sectionsObject[key] = section as HTMLElement;
  }
  return sectionsObject;
}